import { c as _c } from "react/compiler-runtime";
import InputWithSlider from "@components/InputWithSlider";
import { Button, Modal, ModalProps } from "@justhome/react-ui";
import { FC, useCallback } from "react";
import { Control, useForm, useWatch } from "react-hook-form";
import { RepaymentCalculatorFormValue, SpecialRepayment } from "./types";
interface CreateOneTimeRepaymentProps extends ModalProps {
  control: Control<RepaymentCalculatorFormValue>;
  onSubmit: (oneTimeRepayment: SpecialRepayment) => void;
  defaultValues?: SpecialRepayment;
}
const CreateOneTimeRepayment: FC<CreateOneTimeRepaymentProps> = props => {
  const $ = _c(32);
  let t0;
  if ($[0] !== props.control) {
    t0 = {
      control: props.control
    };
    $[0] = props.control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const values = useWatch(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().getFullYear();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const thisYear = t1;
  let t2;
  if ($[3] !== props.defaultValues) {
    t2 = props.defaultValues || {
      year: thisYear + 1,
      amount: 50000
    };
    $[3] = props.defaultValues;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = {
      defaultValues: t2
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    control,
    handleSubmit
  } = useForm(t3);
  const maxAmount = Math.floor((values.loanAmount || 250000) / 25000) * 25000;
  let t4;
  if ($[7] !== props) {
    t4 = value => {
      props.onSubmit(value);
    };
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onSubmit = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Modal.Title className="text-app-h3">Einmalzahlung</Modal.Title>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleSubmit || $[11] !== onSubmit) {
    t6 = handleSubmit(onSubmit);
    $[10] = handleSubmit;
    $[11] = onSubmit;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = thisYear + (values.fixedInterestPeriodYears || 15);
  let t8;
  if ($[13] !== control || $[14] !== t7) {
    t8 = <InputWithSlider format={false} control={control} name="year" label="Jahr der Einmalzahlung" min={thisYear} max={t7} step={1} />;
    $[13] = control;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== control || $[17] !== maxAmount) {
    t9 = <InputWithSlider control={control} name="amount" label="Betrag der Einmalzahlung" min={25000} max={maxAmount} step={25000} suffix={"\u20AC"} />;
    $[16] = control;
    $[17] = maxAmount;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== props) {
    t10 = <Button onClick={() => props.setIsOpen?.(false)} variant="outline_primary" size="sm">Abbrechen</Button>;
    $[19] = props;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Button type="submit" size="sm">Speichern</Button>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10) {
    t12 = <div className="flex gap-s mt-2xs">{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t6 || $[26] !== t8 || $[27] !== t9) {
    t13 = <form className="flex flex-col gap-s" onSubmit={t6}>{t8}{t9}{t12}</form>;
    $[24] = t12;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== props || $[30] !== t13) {
    t14 = <Modal {...props}>{t5}{t13}</Modal>;
    $[29] = props;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
export default CreateOneTimeRepayment;